import { render, staticRenderFns } from "./Q2FA.vue?vue&type=template&id=1c68b793&scoped=true"
import script from "./Q2FA.vue?vue&type=script&lang=js"
export * from "./Q2FA.vue?vue&type=script&lang=js"
import style0 from "./Q2FA.vue?vue&type=style&index=0&id=1c68b793&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c68b793",
  null
  
)

/* custom blocks */
import block0 from "./Q2FA.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports